import clsx from "clsx";
import Link from "./Link";

const LINK_BUTTON_CLASSES =
  "inline-flex items-center gap-1.5 text-sm font-medium text-cyan-450 hover:text-[#0a8ea3] hover:underline underline-offset-2 disabled:opacity-50 disabled:pointer-events-none";

function LinkButton({ to, children, className, ...rest }) {
  const classes = clsx(LINK_BUTTON_CLASSES, className);

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}

export default LinkButton;
